import React from "react";
import * as S from "./imgTemplates.styles";
import { CmpHeader, Header } from "../../molcules/Header";

interface ImgTemplatesProps {
  pageTitle?: string;
  children: React.ReactElement;
  padding?: string;
}

const ImgTemplates = ({ pageTitle, children, padding }: ImgTemplatesProps) => {
  return (
    <S.ImgTemplates>
      <CmpHeader pageTitle={pageTitle} />
      <S.ContentsSection padding={padding}>{children}</S.ContentsSection>
    </S.ImgTemplates>
  );
};

export default ImgTemplates;
